import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';

class RecommendList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        console.log(content);

        return (
            <div className={styles.recommendSlides}>
                <ul className="clearfix">
                    {content.length > 0 &&
                        content.map((item, index) => {
                            return (
                                <li key={index}>
                                    <a href={item.url} target="_blank">
                                        <img src={item.img} alt={item.title} />
                                    </a>
                                    <a href={item.url} target="_blank">
                                        {item.title}
                                    </a>
                                </li>
                            );
                        })}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(RecommendList);
